import cloneDeep from "lodash/cloneDeep";

const copySpeziesFromCreature = (creature) => {
    return cloneDeep(creature.spezies)

}
export default copySpeziesFromCreature;